import { useNavigate } from 'react-router'

import { SkeletonRows } from '@/components/ui/skeleton'
import { useWorkQueue, type WorkQueueItem } from '@/models/workQueue'
import { WorkQueueRow } from './WorkQueueRow'

export function WorkQueue() {
  const navigate = useNavigate()
  const { items, isLoading } = useWorkQueue()

  const goToLead = (item: WorkQueueItem) => navigate(`/insure/internal/sales-leads/${item.id}`)

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 p-6">
      <div>
        <h1 className="text-xl font-semibold">My Queue</h1>
        <p className="text-muted-foreground text-sm">Leads that need attention today, ranked by priority.</p>
      </div>

      {isLoading && <SkeletonRows rows={4} rowClassName="h-24 rounded-lg" />}

      {!isLoading && items.length === 0 && (
        <div className="rounded-lg border border-dashed p-8 text-center">
          <p className="text-muted-foreground text-sm">You&apos;re all caught up. 🎉</p>
        </div>
      )}

      <div className="flex flex-col gap-3">
        {items.map((item) => (
          <WorkQueueRow key={item.id} item={item} onDraftEmail={(it) => goToLead(it)} />
        ))}
      </div>
    </div>
  )
}
